export default "__VITE_ASSET__XeneMn24__"